function formatFieldValue(value, format) {
    let formattedValue = value;

    if (value !== null) {

        switch (format) {
            case "boolean": // display "Yes" or "No"
                formattedValue = value == true ? "Yes" : "No";
                break;

            case "ucfirst": // uppercase first letter
                if (value.length > 0) {
                    formattedValue = value[0].toUpperCase() + value.slice(1);
                }
                break;

            case "datetime":
                if (value === "0000-00-00 00:00:00" || !value) {
                    formattedValue = "";
                }
                else {
                    let date = moment(value);
                    formattedValue = date.format("dddd DD/MM/YYYY @ hh:mm a");
                }
                break;

            case "datetime_no_day":
                if (value === "0000-00-00 00:00:00" || !value) {
                    formattedValue = "";
                }
                else {
                    let date = moment(value);
                    formattedValue = date.format("DD/MM/YYYY @ hh:mm a");
                }
                break;

            case "date":
                if (value === "0000-00-00" || !value) {
                    formattedValue = "";
                }
                else {
                    let datetime = moment(value);
                    formattedValue = datetime.format("DD/MM/YYYY");
                }
                break;

            case "date_or_empty":
                if (value === "0000-00-00" || !value) {
                    formattedValue = "";
                } else {
                    let datetime = moment(value);
                    formattedValue = datetime.format("DD/MM/YYYY");
                }
                if (formattedValue === "01/01/1970" || formattedValue === "00/00/0000") {
                    formattedValue = "";
                }
                break;

            case "day_and_date":
                if (value === "0000-00-00" || !value) {
                    formattedValue = "";
                }
                else {
                    let datetime = moment(value);
                    formattedValue = datetime.format("dddd DD/MM/YYYY");
                }
                break;

            case "job_type":
                switch (value) {
                    case "teleconference":
                        formattedValue = "Teleconference";
                        break;

                    case "videoconference":
                        formattedValue = "Videoconference";
                        break;

                    case "onsite":
                        formattedValue = "Onsite Booking";
                        break;
                }
                break;

            case "job_code":
                switch (value) {
                    // main job codes
                    case "court":
                        formattedValue = "Court";
                        break;

                    case "medical":
                        formattedValue = "Medical";
                        break;

                    case "conference":
                        formattedValue = "Conference";
                        break;

                    case "investigation":
                        formattedValue = "Investigation";
                        break;

                    case "federal_court":
                        formattedValue = "Federal Court";
                        break;

                    // sub job codes
                    // court
                    case "court_conference":
                        formattedValue = "Conference";
                        break;

                    case "court_in_room":
                        formattedValue = "In Room";
                        break;

                    // medical
                    case "medical_centre":
                        formattedValue = "Medical Centre";
                        break;

                    case "medical_home_visit":
                        formattedValue = "Home visit";
                        break;

                    case "medical_library":
                        formattedValue = "Library";
                        break;

                    case "medical_work_place_visit":
                        formattedValue = "Work Place Visit";
                        break;

                    case "medical_distant_suburb":
                        formattedValue = "Distant Suburb";
                        break;

                    // conference
                    case "conference_office":
                        formattedValue = "Office";
                        break;

                    case "conference_home_visit":
                        formattedValue = "Home Visit";
                        break;

                    case "conference_correctional_centre":
                        formattedValue = "Correctional Centre";
                        break;

                    case "conference_work_place_visit":
                        formattedValue = "Work Place Visit";
                        break;

                    case "conference_airport":
                        formattedValue = "Airport";
                        break;

                    case "conference_distant_suburb":
                        formattedValue = "Distant Suburb";
                        break;

                    // short teleconference
                    case "teleconference_short":
                        formattedValue = "Short Teleconference (< 30 min)";
                        break;

                    default:
                        formattedValue = "";
                        break;
                }
                break;

            case "sub_job_code_and_parent":

                switch (value) {
                    // court
                    case "court":
                        formattedValue = "Court";
                        break;

                    case "court_conference":
                        formattedValue = "Court (Conference)";
                        break;

                    case "court_in_room":
                        formattedValue = "Court (In Room)";
                        break;

                    // medical
                    case "medical":
                        formattedValue = "Medical";
                        break;

                    case "medical_centre":
                        formattedValue = "Medical (Medical Centre)";
                        break;

                    case "medical_home_visit":
                        formattedValue = "Medical (Home visit)";
                        break;

                    case "medical_library":
                        formattedValue = "Medical (Library)";
                        break;

                    case "medical_work_place_visit":
                        formattedValue = "Medical (Work Place Visit)";
                        break;

                    case "medical_distant_suburb":
                        formattedValue = "Medical (Distant Suburb)";
                        break;

                    // conference
                    case "conference":
                        formattedValue = "Conference";
                        break;

                    case "conference_office":
                        formattedValue = "Conference (Office)";
                        break;

                    case "conference_home_visit":
                        formattedValue = "Conference (Home Visit)";
                        break;

                    case "conference_correctional_centre":
                        formattedValue = "Conference (Correctional Centre)";
                        break;

                    case "conference_work_place_visit":
                        formattedValue = "Conference (Work Place Visit)";
                        break;

                    case "conference_airport":
                        formattedValue = "Conference (Airport)";
                        break;

                    case "conference_distant_suburb":
                        formattedValue = "Conference (Distant Suburb)";
                        break;

                    // short teleconference
                    case "teleconference_short":
                        formattedValue = "Short Teleconference (< 30 min)";
                        break;

                    default:
                        formattedValue = "";
                        break;
                }
                break;

            case "interpreter_status":
                switch (value) {
                    case 'terminated':
                        formattedValue = "Terminated";
                        break;

                    case 'interpreting_inactive':
                        formattedValue = "Inactive for interpreting";
                        break;

                    case 'translating_inactive':
                        formattedValue = "Inactive for translating";
                        break;

                    case 'both_inactive':
                        formattedValue = "Inactive";
                        break;

                    default:
                    case 'current':
                        formattedValue = "Active";
                        break;
                }
                break;

            case "translation_client_type":
                switch (value) {
                    case 1:
                        formattedValue = "1 : Deposit and full payment required";
                        break;
                    case 2:
                        formattedValue = "2 : Full payment required";
                        break;
                    case 3:
                        formattedValue = "3 : Regular client (full credit)";
                        break;
                }
                break;

            case "day_required":
                switch (value) {
                    case "speed": 
                        formattedValue = "Urgent (< 2 business days)";
                        break;
                    
                    case "urgent":
                        formattedValue = "Urgent (< 5 days)";
                        break;

                    default:
                        formattedValue = "Normal";
                        break;
                }
                break;
        }
    }

    return formattedValue;
}

function populateObjectData(container, object, prefix, fieldsFormats) {
	Object.keys(object).forEach(field => {
		let value = object[field];
		if (typeof value === 'object' && value !== null) {
			let subFieldsFormats = field in fieldsFormats ? fieldsFormats[field] : {};
			populateObjectData(container, value, field + "-", subFieldsFormats);
		}
		else {
			// use raw values for radios and checkboxes
			$(container).find(`input:radio[name=${prefix + field}]`).each(function () {
				$(this).prop('checked', $(this).val() == value ? true : null);
			});
			$(container).find(`input:checkbox[name=${prefix + field}]`).each(function () {
				$(this).prop('checked', $(this).val() == value ? true : null);
			});

			// format values for labels and text inputs
			if (field in fieldsFormats) {
				value = formatFieldValue(value, fieldsFormats[field]);
			}
			$(container).find(`[data-name=${prefix + field}]`).append(value);
			$(container).find(`[name=${prefix + field}]:not(:checkbox):not(:radio)`).val(value);
		}
	});
}

$.fn.extend({
    loadATLObject: function (options) {

        if (this.length == 0) return;

        var container = this[0];

        options = options || {};
        var endpoint = options.endpoint;
        var objectId = options.objectId;
        var errorMessage = options.errorMessage || "Something went wrong.";
        var errorRedirectURL = options.errorRedirectURL;
        var fieldsFormats = options.fieldsFormats || {};

        if (!endpoint) {
            alert("Endpoint missing");
            return;
        }

        if (!objectId) {
            alert("Object ID missing");
            return;
        }

        // display loader
        $(container).prepend('<div class="loader-overlay"><div class="spinner-grow page-loader"></div></div>');

        // make request to API
        $.ajax({
            type: "GET",
            url: getApiURL(endpoint) + "/" + objectId,
            headers: { "Token": $.cookie('token_api') },
            dataType: "json",
            success: function (object) {
                populateObjectData(container, object, '', fieldsFormats);
                if (typeof options.success === "function") {
                    options.success(object);
                }
                $(container).find(".loader-overlay").remove();
            },
            error: function (request, textStatus, errorThrown) {
                ATLAlerts.addError(errorMessage);
                if (errorRedirectURL) {
                    window.location.href = errorRedirectURL;
                }
                else {
                    $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                    $(container).find(".loader-overlay").remove();
                }
            }
        });
    }
});